export class Filters {
  account = '';
  period = {
    from: '',
    to: '',
  };
  newFilterDate = {
    from: '',
    to: ''
  };
  orderstatus: number = -1;
  categoryroot = null;
  categoryl1 = null;
  categoryl2 = null;
  categoryl3 = null;
  customername = '';
  customerlastname = '';
  customeremail = '';
  label = '';
  department = '';
  service = null;
  vendor?;
  type: number = -1;
  hidden?: boolean = false;
  loadFilterId?;
  partner = null;
}

export class Filter {
  id: string;
  account: string;
  name: string;
  data: Filters = new Filters();
}
